export default "__VITE_ASSET__DQsYSeZT__"